/* Built-in SQL Functions */
export default {
  mathFunc: {
    zh_cn: '数学函数',
    en: 'Mathematical Functions',
  },
  dataTypeJudgmentFunc: {
    zh_cn: '数据类型判断函数',
    en: 'Data Type Judgment Functions',
  },
  dataTypeConversionFunc: {
    zh_cn: '数据类型转换函数',
    en: 'Data Type Conversion Functions',
  },
  stringFunc: {
    zh_cn: '字符串函数',
    en: 'String Functions',
  },
  mapFunc: {
    zh_cn: 'Map 函数',
    en: 'Map Functions',
  },
  arrFunc: {
    zh_cn: '数组函数',
    en: 'Array Functions',
  },
  hashFunc: {
    zh_cn: '哈希函数',
    en: 'Hash Functions',
  },
  compressesAndUncompressesFunc: {
    zh_cn: '压缩解压缩函数',
    en: 'Compression and Decompression Functions',
  },
  bitFunc: {
    zh_cn: '比特操作函数',
    en: 'Bit Functions',
  },
  decodingAndEncodingFunc: {
    zh_cn: '编解码函数',
    en: 'Decoding and Encoding Functions',
  },
  timeAndDateFunc: {
    zh_cn: '时间与日期函数',
    en: 'Time and Date Functions',
  },
  schemaRegistry: {
    zh_cn: '编解码',
    en: 'Schema Registry',
  },
  /* PARAMS */
  Value: {
    zh_cn: '值',
    en: 'Value',
  },
  Base: {
    zh_cn: '基数',
    en: 'Base',
  },
  Exponent: {
    zh_cn: '指数',
    en: 'Exponent',
  },
  Numer: {
    zh_cn: '分子',
    en: 'Numer',
  },
  Denom: {
    zh_cn: '分母',
    en: 'Denom',
  },
  Precision: {
    zh_cn: '精度',
    en: 'Precision',
  },
  String: {
    zh_cn: '字符串',
    en: 'String',
  },
  StartPosition: {
    zh_cn: '起始位置',
    en: 'Start Position',
  },
  Separator: {
    zh_cn: '分割符',
    en: 'Separator',
  },
  Direction: {
    zh_cn: '方向',
    en: 'Direction',
  },
  String1: {
    zh_cn: '左字符串',
    en: 'String1',
  },
  String2: {
    zh_cn: '右字符串',
    en: 'String2',
  },
  PreserveCRLF: {
    zh_cn: '是否保留换行符',
    en: 'Preserve CRLF',
  },
  TotalLength: {
    zh_cn: '字符总长度',
    en: 'Total Length',
  },
  PaddingDirection: {
    zh_cn: '补足方向',
    en: 'Padding Direction',
  },
  PaddingString: {
    zh_cn: '补足字符',
    en: 'Padding String',
  },
  OldSubStr: {
    zh_cn: '需要替换的字符串',
    en: 'Old Sub Str',
  },
  Replacement: {
    zh_cn: '替换值',
    en: 'Replacement',
  },
  ReplaceCount: {
    zh_cn: '替换位置',
    en: 'Replace Count',
  },
  Pattern: {
    zh_cn: '正则表达式',
    en: 'Pattern',
  },
  Character: {
    zh_cn: '字符',
    en: 'Character',
  },
  SubstringToBeFound: {
    zh_cn: '要查找的子串',
    en: 'Substring To Be Found',
  },
  DirectionToFind: {
    zh_cn: '查找方向',
    en: 'Direction To Find',
  },
  Key: {
    zh_cn: '键',
    en: 'Key',
  },
  Map: {
    zh_cn: 'Map',
    en: 'Map',
  },
  DefaultValue: {
    zh_cn: '默认值',
    en: 'Default Value',
  },
  Index: {
    zh_cn: '索引',
    en: 'Index',
  },
  Array: {
    zh_cn: '数组',
    en: 'Array',
  },
  StartIndex: {
    zh_cn: '起始索引',
    en: 'Start Index',
  },
  Length: {
    zh_cn: '截取长度',
    en: 'Length',
  },
  UnixTimestamp: {
    zh_cn: 'Unix 时间戳',
    en: 'Unix Timestamp',
  },
  TimeUnit: {
    zh_cn: '时间单位',
    en: 'Time Unit',
  },
  RFC3339String: {
    zh_cn: 'RFC 3339 时间字符串',
    en: 'RFC3339 Time String',
  },
  TimeOffset: {
    zh_cn: '时区偏移',
    en: 'Time Offset',
  },
  DateFormat: {
    zh_cn: '日期格式',
    en: 'Date Format',
  },
  Timestamp: {
    zh_cn: '时间戳',
    en: 'Timestamp',
  },
  BinaryData: {
    zh_cn: '二进制数据',
    en: 'Binary Data',
  },
  BinaryStartIndex: {
    zh_cn: '起始位置的下标',
    en: 'Start Index',
  },
  DataType: {
    zh_cn: '数据类型',
    en: 'Data Type',
  },
  Signedness: {
    zh_cn: '符号性',
    en: 'Signedness',
  },
  Endian: {
    zh_cn: '字节序',
    en: 'Endian',
  },
}
